import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "@js/partials/single-carousel";

document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollTrigger);

  const flipperCards = document.querySelectorAll(".flipper-cards");

  flipperCards.forEach((block) => {
    const flipperCardWrappers = block.querySelectorAll(".flipper-card-wrapper");

    gsap.set(flipperCardWrappers, { opacity: 0, yPercent: 15 });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: block,
        start: "top 80%",
        end: "top 50%",
        toggleActions: "play none none none",
      },
    });

    flipperCardWrappers.forEach((wrapper, index) => {
      tl.to(
        wrapper,
        {
          opacity: 1,
          yPercent: 0,
          duration: 1,
          ease: "power2.out",
        },
        index * 0.2
      );
    });

    // Functionality only for mobile: add "active" class when each card comes into view
    const isMobile = window.innerWidth < 1024;

    if (isMobile) {
      flipperCardWrappers.forEach((wrapper) => {
        ScrollTrigger.create({
          trigger: wrapper,
          start: "top 60%",
          end: "bottom 40%",
          onEnter: () => wrapper.classList.add("active"),
          onLeave: () => wrapper.classList.remove("active"),
          onEnterBack: () => wrapper.classList.add("active"),
          onLeaveBack: () => wrapper.classList.remove("active"),
        });
      });
    }
  });
});
